import { render, staticRenderFns } from "./OrderHistoryTable.vue?vue&type=template&id=56cdd014&scoped=true&"
import script from "./OrderHistoryTable.vue?vue&type=script&lang=js&"
export * from "./OrderHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./OrderHistoryTable.vue?vue&type=style&index=0&id=56cdd014&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cdd014",
  null
  
)

export default component.exports